import React from 'react'
import { ButtonBase, Chip, Stack, Typography } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'
import { useCreateDraftConfiguredServiceContext } from './CreateDraftConfiguredServiceContext'
import useActiveFilterCount from './hooks/useActiveFilterCount'

const FilterToggleButton = () => {
  const {
    handleToggleFilterPanel,
    handleOpenMobileFilterPanel,
    handleCloseMobileFilterPanel,
    control,
    isFilterPanelOpen,
    isMobileFilterOpen,
    isDesktop,
  } = useCreateDraftConfiguredServiceContext()
  const activeFilterCount = useActiveFilterCount(control)

  if (isDesktop && isFilterPanelOpen) return null

  let handleClick
  if (isDesktop) {
    handleClick = handleToggleFilterPanel
  } else if (isMobileFilterOpen) {
    handleClick = handleCloseMobileFilterPanel
  } else {
    handleClick = handleOpenMobileFilterPanel
  }

  return (
    <ButtonBase
      onClick={handleClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 1.5,
        py: 0.75,
        bgcolor: 'background.default',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        gap: 1,
        flexShrink: 0,
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={0.75}>
        <Typography variant="body1" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
          Filter options
        </Typography>
        {activeFilterCount > 0 && (
          <Chip label={activeFilterCount} size="small" color="primary" sx={{ height: 18, minWidth: 18, '& .MuiChip-label': { px: 0, fontSize: '0.65rem' } }} />
        )}
      </Stack>
      <TuneIcon fontSize="small" sx={{ color: 'text.secondary', flexShrink: 0 }} />
    </ButtonBase>
  )
}

export default FilterToggleButton
